<template>
    <footer>
        <a href="https://twitter.com/tiagoleonmelo">Twitter</a> <a href="https://github.com/tiagoleonmelo">GitHub</a> <a href="https://medium.com/@tiagomelosw">Medium</a>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
footer {
    height: 20px;
    text-align: center;
}
a {
    color: #660000
}
a:hover {
    color: #660000
}
</style>
